import { render, staticRenderFns } from "./ShipDeliveryContentTable.vue?vue&type=template&id=7e313f53&scoped=true&"
import script from "./ShipDeliveryContentTable.vue?vue&type=script&lang=js&"
export * from "./ShipDeliveryContentTable.vue?vue&type=script&lang=js&"
import style0 from "./ShipDeliveryContentTable.vue?vue&type=style&index=0&id=7e313f53&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e313f53",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
